import store from "../../store"
export default () => {
    return store.getters.empresa.venderSemEstoque
}